// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"HomeEducationalServiceMobileItem_Wrapper__3li1m","Image":"HomeEducationalServiceMobileItem_Image__3Aww5","Name":"HomeEducationalServiceMobileItem_Name__30d3C"};